import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { isOnboardingCompleted, waitForOnboardingSync } from "../utils/onboarding";
import { useNzJourneyStatus } from "../hooks/useNzJourneyStatus";
import { hasValidSession } from "../hooks/api";
import AppLoader from "./common/AppLoader/AppLoader";

const SYNC_TIMEOUT_MS = 5000;
const MIN_LOADER_MS = 2500;

export const OnboardingRedirect = () => {
  const [ready, setReady] = useState(false);
  const { loading: nzJourneyLoading, canAccessHome } = useNzJourneyStatus();

  useEffect(() => {
    let cancelled = false;
    const start = Date.now();

    const finish = () => {
      if (cancelled) return;
      const elapsed = Date.now() - start;
      const remaining = Math.max(0, MIN_LOADER_MS - elapsed);
      setTimeout(() => { if (!cancelled) setReady(true); }, remaining);
    };

    const timeout = setTimeout(finish, SYNC_TIMEOUT_MS);
    waitForOnboardingSync().then(() => { clearTimeout(timeout); finish(); });

    return () => { cancelled = true; clearTimeout(timeout); };
  }, []);

  // `/` no pasa por ProtectedRoute (ver AppRoutes), así que es el único lugar donde se puede
  // cortar cuando no hay sesión. Sin sesión no hay `psychologistId`, y sin id
  // `useNzJourneyStatus` nunca sale de `loading`: el AppLoader se quedaba para siempre en vez
  // de mandar al login. Va después de los hooks para no romper el orden de ejecución.
  if (!hasValidSession()) {
    return <Navigate to="/login" replace />;
  }

  if (!ready || nzJourneyLoading) {
    return <AppLoader />;
  }

  // Mientras esté dentro del journey NZ (activa, u "O" recién graduada sin confirmar el
  // egreso), nunca aterriza en Home por default — va directo a Agenda, sea o no la primera vez.
  if (!canAccessHome) {
    return <Navigate to="/calendar" replace />;
  }

  return <Navigate to={isOnboardingCompleted() ? "/calendar" : "/home"} replace />;
};
